








































































































/* eslint-disable */

import Vue from "vue";
import fb from "../config";
import router from './router/routes.vue';

export default Vue.extend({
  name: "#contact",
  data() {
    return {
     newsletter: ""
    };
  },
  methods: {
    insertNewsLetter() {
      var cur = this;
fb.firestore()
        .collection("newsletter")
        .add({
          newsletter: this.newsletter,
          time:new Date().toLocaleString()
        })
        .then(function() {
          alert("Email Received");
          cur.newsletter = "";
        })
        .catch(function() {
          alert("error");
        });
    

      
    },
  },
});
